import { Text, View } from "@react-pdf/renderer";
import { centsToDollars, parsePrice } from "helpers/price";
import { useMemo } from "react";
import { IUniqueProceduresByProvider } from "types/Order/Order";

import { styles } from "../styles";

export type Props = {
  surgeonFees: number;
  anesthesiaFees: number;
  facilityFees: number;
  scd: number;
  exparel: number;
  clearPriceToPay: number;
  clearPatientFeeValueInPercentage?: number | null;
  proceduresByProviders: IUniqueProceduresByProvider[];
};

export function ChargeDescriptionV3({
  surgeonFees,
  anesthesiaFees,
  facilityFees,
  scd,
  exparel,
  clearPriceToPay,
  proceduresByProviders,
  clearPatientFeeValueInPercentage,
}: Props) {
  const clearPatientFee = useMemo(() => {
    const subtotal = proceduresByProviders.reduce(
      (acc: any, proceduresByProvider: any) => {
        return acc + proceduresByProvider.subtotal;
      },
      0
    );
    return clearPatientFeeValueInPercentage
      ? subtotal * (clearPatientFeeValueInPercentage / 100)
      : 0;
  }, [proceduresByProviders, clearPatientFeeValueInPercentage]);
  return (
    <View style={{ marginLeft: 50, marginRight: 50 }}>
      <View
        style={{
          display: "flex",
          width: "100%",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <View style={styles.table}>
          <View style={[styles.row, styles.headerRow]}>
            <Text style={(styles.cell, styles.leftCell)}>
              CHARGE DESCRIPTION
            </Text>
            <Text style={(styles.cell, styles.rightCell)}>AMOUNT</Text>
          </View>

          <>
            <View style={[styles.row, styles.grayBackground]}>
              <Text style={[styles.cell, styles.leftCell]}>Surgeon fees</Text>
              <Text
                style={[styles.cell, styles.rightCell, styles.rightCellBorder]}
              >
                {parsePrice(centsToDollars(surgeonFees))}
              </Text>
            </View>
            <View style={styles.row}>
              <Text style={[styles.cell, styles.leftCell]}>
                Anesthesia fees
              </Text>
              <Text
                style={[styles.cell, styles.rightCell, styles.rightCellBorder]}
              >
                {parsePrice(centsToDollars(anesthesiaFees))}
              </Text>
            </View>
            <View style={[styles.row, styles.grayBackground]}>
              <Text style={[styles.cell, styles.leftCell]}>Facility fees</Text>
              <Text
                style={[styles.cell, styles.rightCell, styles.rightCellBorder]}
              >
                {parsePrice(centsToDollars(facilityFees))}
              </Text>
            </View>
            {exparel && (
              <View style={styles.row}>
                <Text style={[styles.cell, styles.leftCell]}>Exparel</Text>
                <Text
                  style={[
                    styles.cell,
                    styles.rightCell,
                    styles.rightCellBorder,
                  ]}
                >
                  {parsePrice(centsToDollars(exparel))}
                </Text>
              </View>
            )}
            {scd && (
              <View style={{ ...styles.row, backgroundColor: "#a5c9eb" }}>
                <Text style={[styles.cell, styles.leftCell]}>SCD</Text>
                <Text
                  style={[
                    styles.cell,
                    styles.rightCell,
                    styles.rightCellBorder,
                  ]}
                >
                  {parsePrice(centsToDollars(scd))}
                </Text>
              </View>
            )}
            {clearPatientFeeValueInPercentage && (
              <View style={{ ...styles.row }}>
                <Text style={[styles.cell, styles.leftCell]}>
                  Convenience and service fees
                </Text>
                <Text
                  style={[
                    styles.cell,
                    styles.rightCell,
                    styles.rightCellBorder,
                  ]}
                >
                  {parsePrice(centsToDollars(clearPatientFee))}
                </Text>
              </View>
            )}
            <View
              style={{
                ...styles.row,
                backgroundColor: "#426393",
                color: "#fff",
                fontSize: 12,
                fontFamily: "Helvetica-Bold",
                fontWeight: 900,
              }}
            >
              <Text style={[styles.cell, styles.leftCell]}>
                Total Responsibility
              </Text>
              <Text
                style={[styles.cell, styles.rightCell, styles.rightCellBorder]}
              >
                {parsePrice(centsToDollars(clearPriceToPay))}
              </Text>
            </View>
          </>
        </View>
      </View>
    </View>
  );
}
